import './App.css';
import Header from './components/Header';
import Footer from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import About from "./pages/About";
import Works from "./pages/Works";
import {ThemeProvider} from "./providers/themeProvider";
import Contacts from "./pages/Contacts";
import Work from "./pages/Work";
import { Provider } from 'react-redux';
import store from "./redux/store";
import WorkInner from './pages/WorkInner';
import Videos from "./pages/Videos";
import Session from "./pages/Session";
import Caliber from "./pages/Caliber";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <div className="max-w-[1680px] m-auto w-full bg-lightBg dark:bg-darkBg">
          <Router>
            <Header />
            <Routes>
              <Route path="/" element={<About />} />
              <Route path="/about" element={<About />} />
              <Route path="/category" element={<Works />} />
              <Route path="/category/:id" element={<Work />} />
              <Route path="/products/:id" element={<WorkInner />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/session" element={<Session />} />
              <Route path="/caliber" element={<Caliber />} />
            </Routes>
            <Footer />
            <Toaster />
          </Router>
        </div>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
